import { StyleSheet, View } from 'react-native';

import {
  ScreenSizes,
  useScreenSize,
  useStylesForWidth
} from '../hooks/useStyleForWidth';
import { DashboardBannerImage } from '../img/dashboard-banner/DashboardBannerImage';
import { DashboardBannerSMImage } from '../img/dashboard-banner-sm/DashboardBannerSMImage';
import { AppStyles } from '../services/styles';

const ScreenBannerImage = () => {
  const ImageClass =
    useScreenSize() === ScreenSizes.SM
      ? DashboardBannerSMImage
      : DashboardBannerImage;
  return (
    <View style={useStylesForWidth(styles, 'sbiWrapper')} role="complementary">
      <ImageClass style={useStylesForWidth(styles, 'sbiImage')} />
    </View>
  );
};

const styles = StyleSheet.create({
  sbiWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    overflow: 'hidden',
    backgroundColor: '#2b66aa',
    borderBottomLeftRadius: AppStyles.largeBorderRadius
  },
  sbiWrapperMDLGXL: {
    height: 400,
    borderTopLeftRadius: AppStyles.largeBorderRadius
  },
  sbiWrapperSM: {
    height: 300,
    borderBottomRightRadius: AppStyles.largeBorderRadius
  },
  sbiImage: {
    width: '100%',
    height: '100%'
  }
});

export { ScreenBannerImage };
